import Typography from "@material-ui/core/Typography";
import {
  Grid,
  Divider,
  Box,
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

interface TitleDividerProps {
  title: string;
  onClick: () => void;
  showButton: boolean;
}

export const TitleDividerWithButton = ({ title, onClick, showButton }: TitleDividerProps) => {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Typography variant="subtitle1" style={{ color: "#5E5E5E" }}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs>
        <Box display="flex" alignItems="center">
          <Divider style={{ flexGrow: 1 }} />
          {showButton &&
            <IconButton onClick={onClick} size="small">
              <EditIcon style={{ fontSize: 19 }} />
            </IconButton>
          }
        </Box>
      </Grid>
    </Grid>
  );
};